import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[requireStringMatch]',
  providers: [{provide: NG_VALIDATORS, useExisting: RequireStringMatchDirective, multi: true}]
})

export class RequireStringMatchDirective implements Validator {
  @Input() options: any[];

  validate(control: AbstractControl): { [key: string]: any } {
    if (control && control.value && !this.options.find(value => value.name === control?.value)) {
      return {incorrect: true};
    }
    return null;
  }
}
